export default "__VITE_ASSET__570b05b7__"